//#region Imports

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { CoverImageUploadComponent } from '../cover-image-upload/cover-image-upload.component';
import { IconComponent } from '../icon/icon.component';
import { InputComponent } from '../input/input.component';
import { TagSelectComponent } from '../tag-select/tag-select.component';
import { DecimalInputDirective } from '../../directives/decimal-input/decimal-input.directive';
import { Category } from '../../models/interfaces/category.interface';
import { CourseAboutForm } from '../../models/interfaces/forms/course-form.interface';
import { CourseType } from '../../models/enums/course-type.enum';
import { CourseLocation } from '../../models/enums/course-location.enum';
import { COURSE_TYPE_LABELS } from '../../models/records/course-type.record';
import { COURSE_LOCATION_LABELS } from '../../models/records/course-location.record';

//#endregion

@Component({
  selector: 'l-course-about-step',
  standalone: true,
  templateUrl: './course-about-step.component.html',
  host: {
    class: 'flex flex-1 flex-col',
  },
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    CoverImageUploadComponent,
    IconComponent,
    InputComponent,
    TagSelectComponent,
    DecimalInputDirective,
  ],
})
export class CourseAboutStepComponent {

  //#region Public Properties

  @Input({ required: true })
  public aboutForm!: FormGroup<CourseAboutForm>;

  @Input({ required: true })
  public categories: Category[] = [];

  @Output()
  public readonly coverPreviewStateChange = new EventEmitter<boolean>();

  @Output()
  public readonly coverPreviewSrcChange = new EventEmitter<string>();

  @Output()
  public readonly coverFileChange = new EventEmitter<File | null>();

  public readonly typeOptions = Object.values(CourseType).map((value) => ({
    label: COURSE_TYPE_LABELS[value],
    value,
  }));

  public readonly locationOptions = Object.values(CourseLocation).map((value) => ({
    label: COURSE_LOCATION_LABELS[value],
    value,
  }));

  //#endregion

  //#region Getters

  public get imageUrl(): string {
    return this.aboutForm.controls.coverImageUrl.value;
  }

  public set imageUrl(value: string) {
    this.aboutForm.controls.coverImageUrl.setValue(value);
  }

  //#endregion

  //#region Public Methods

  public onCoverPreviewState(hasPreview: boolean): void {
    this.coverPreviewStateChange.emit(hasPreview);
  }

  public onCoverPreviewSrcChange(src: string): void {
    this.coverPreviewSrcChange.emit(src);
  }

  public onCoverFileChange(file: File | null): void {
    this.coverFileChange.emit(file);
  }

  //#endregion

}
